import { render, staticRenderFns } from "./ProfileUpload.vue?vue&type=template&id=128187a2&scoped=true&"
import script from "./ProfileUpload.vue?vue&type=script&lang=js&"
export * from "./ProfileUpload.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUpload.vue?vue&type=style&index=0&id=128187a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128187a2",
  null
  
)

export default component.exports